import { useTranslation } from "react-i18next";

import Button from "components/Button";
import ImageCreator from "components/ImageCreator";
import Spinner from "components/Spinner";

import DeleteSignatureStampDialog from "../DeleteItemDialog";

import { useStamp } from "./useStamp";

interface StampProps {
  templateStampPath: string | null;
}

export default function Stamp({ templateStampPath }: StampProps) {
  const { data, isFetching, stampInputRef, handleStampChange, deleteStampMutation } = useStamp({ templateStampPath });
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3.5">
      <div>{t("profile.findings.digitalStamp")}</div>
      <input
        ref={stampInputRef}
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/gif"
        className="hidden"
        onChange={handleStampChange}
      />
      {!templateStampPath && (
        <Button type="button" className="w-full" onClick={() => stampInputRef.current?.click()} variant="dotted">
          {t("button.upload")}
        </Button>
      )}
      {templateStampPath && (
        <>
          <ImageCreator data={data} alt="Stamp preview" className="max-h-40 object-contain bg-general-gray-300" />
          <div className="flex items-center gap-2">
            <DeleteSignatureStampDialog onConfirm={() => deleteStampMutation.mutate()} stamp={data} />
          </div>
        </>
      )}

      {isFetching && (
        <div className="flex items-center justify-center h-40 bg-general-gray-300">
          <Spinner />
        </div>
      )}
    </div>
  );
}
